import React, { useState } from "react";
import { CircularProgress, Stack, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./InputDropdown.module.scss";

export default function InputDropdown(props) {
  const {
    options,
    placeholder,
    disabled,
    error,
    errorMessage,
    className,
    tooltip,
    tooltipMessage,
    nameLoading,
  } = props;

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchTerm(query);

    // Filter based on 'text' and 'alternate text'
    setFilteredOptions(
      options?.filter((option) => {
        const optionText = option.text.toLowerCase();
        const altTexts =
          option.alterTexts?.map((alt) => alt.toLowerCase()) || [];

        return (
          optionText.includes(query) ||
          altTexts.some((alt) => alt.includes(query))
        );
      })
    );
  };

  const handleOptionClick = (option) => {
    window.open(option.url, "_blank");

    setSearchTerm("");
    setFilteredOptions(options);
  };

  return (
    <Stack className={classNames(styles.customInputContainer, className)}>
      <div className={styles.positionRelative}>
        <input
          type="text"
          disabled={disabled}
          value={searchTerm}
          placeholder={placeholder}
          onChange={handleSearchChange}
          className={classNames({
            [styles.customInputTextField]: true,
            [styles.customInputTextfielderror]: error,
          })}
        />
        {nameLoading && (
          <CircularProgress
            size={20}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />
        )}
        {tooltip && (
          <Tooltip disableFocusListener title={tooltipMessage}>
            <span className={styles.tooltipIcon}>ℹ️</span>
          </Tooltip>
        )}
      </div>
      {error && <div className={styles.errorText}>{errorMessage}</div>}
      {filteredOptions?.length > 0 && searchTerm && (
        <div className={styles.dropdown}>
          {filteredOptions?.map((option, index) => (
            <div
              key={index}
              className={styles.dropdownItem}
              onClick={() => handleOptionClick(option)}
            >
              {option.text}
            </div>
          ))}
        </div>
      )}
    </Stack>
  );
}

InputDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  tooltip: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  nameLoading: PropTypes.bool,
};
